// frontend/src/features/equipment/EquipmentSetupWizard/steps/OtherStep.tsx
import { CategoryStep } from './CategoryStep';
import type { PendingEquipment } from '../types';

interface OtherStepProps {
  pendingEquipment: PendingEquipment[];
  onEquipmentChange: (equipment: PendingEquipment[]) => void;
  onManageInEquipment?: () => void;
  isCategoryComplete?: boolean;
}

export function OtherStep({
  pendingEquipment,
  onEquipmentChange,
  onManageInEquipment,
  isCategoryComplete,
}: OtherStepProps) {
  return (
    <CategoryStep
      categoryId="other"
      title="Any other equipment to track?"
      pendingEquipment={pendingEquipment}
      onEquipmentChange={onEquipmentChange}
      onManageInEquipment={onManageInEquipment}
      isCategoryComplete={isCategoryComplete}
    />
  );
}
